import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "text-alt styled-content" }
const _hoisted_4 = {
  key: 1,
  class: "user-references"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Signature = _resolveComponent("Signature")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Declaration = _resolveComponent("Declaration")!
  const _component_UserReferenceList = _resolveComponent("UserReferenceList")!

  return (_ctx.isMounted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ActionHeader, {
          hotspotDescription: _ctx.hotspotDescription,
          actionTitle: _ctx.actionTitle,
          actionDescription: _ctx.actionDescription
        }, null, 8, ["hotspotDescription", "actionTitle", "actionDescription"]),
        (!_ctx.authoritytoDiscloseCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h3", null, [
                _createVNode(_component_TranslatedText, { path: "references.authority-to-disclose" })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("p", null, [
                  _createVNode(_component_TranslatedText, {
                    path: "references.authority-to-disclose-p1",
                    replacements: [
              {
                placeholder: 'tenant',
                value:
                  _ctx.tenant?.name.charAt(0).toUpperCase() + _ctx.tenant?.name.slice(1),
              },
            ]
                  }, null, 8, ["replacements"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_TranslatedText, {
                    path: "references.authority-to-disclose-p2",
                    replacements: [
              {
                placeholder: 'tenant',
                value:
                  _ctx.tenant?.name.charAt(0).toUpperCase() + _ctx.tenant?.name.slice(1),
              },
            ]
                  }, null, 8, ["replacements"])
                ]),
                _createElementVNode("p", null, [
                  _createVNode(_component_TranslatedText, { path: "references.authority-to-disclose-p3" })
                ])
              ]),
              (_ctx.wetSignature)
                ? (_openBlock(), _createBlock(_component_checkbox, {
                    key: 0,
                    text: "declaration.consent",
                    onChange: _cache[0] || (_cache[0] = () => (_ctx.authorityToDisclose = !_ctx.authorityToDisclose)),
                    id: "auth-check",
                    value: _ctx.authorityToDisclose
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
              _createVNode(_component_Button, {
                text: "references.authority-to-disclose-sign",
                size: "sm",
                disabled: !_ctx.authorityToDisclose && _ctx.wetSignature,
                onClick: _ctx.handleSignClick
              }, null, 8, ["disabled", "onClick"]),
              _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
              _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
              (_ctx.wetSignature)
                ? (_openBlock(), _createBlock(_component_Modal, {
                    key: 1,
                    modelValue: _ctx.showModal,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showModal) = $event)),
                    title: "signature.title",
                    showFooter: false,
                    onCancel: _ctx.handleModalHide
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Signature, {
                        modelValue: _ctx.declarationWet,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.declarationWet) = $event)),
                        onConfirm: _ctx.signAuthorityToDiscloseHandler,
                        onCancel: _ctx.handleModalHide
                      }, null, 8, ["modelValue", "onConfirm", "onCancel"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onCancel"]))
                : _createCommentVNode("", true),
              (!_ctx.wetSignature)
                ? (_openBlock(), _createBlock(_component_Modal, {
                    key: 2,
                    modelValue: _ctx.showModal,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showModal) = $event)),
                    title: "signature.title",
                    onConfirm: _ctx.signAuthorityToDiscloseHandler,
                    onCancel: _ctx.handleModalHide,
                    onDismiss: _ctx.handleModalHide
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Declaration, {
                        modelValue: _ctx.declaration,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.declaration) = $event)),
                        isValid: _ctx.isValid,
                        "onUpdate:isValid": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isValid) = $event)),
                        line1: "references.authority-to-disclose-confirm"
                      }, null, 8, ["modelValue", "isValid"])
                    ]),
                    footer: _withCtx(({ confirm, cancel }) => [
                      _createVNode(_component_Button, {
                        text: "declaration.submit",
                        size: "sm",
                        disabled: !_ctx.isValid,
                        onClick: confirm
                      }, null, 8, ["disabled", "onClick"]),
                      _createVNode(_component_Button, {
                        text: "common.cancel",
                        size: "sm",
                        outline: "",
                        onClick: cancel
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onConfirm", "onCancel", "onDismiss"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.model && _ctx.authoritytoDiscloseCompleted)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("section", null, [
                _createElementVNode("h5", null, [
                  _createVNode(_component_TranslatedText, { path: "references.employer-references" })
                ]),
                _createVNode(_component_UserReferenceList, {
                  references: _ctx.employerReferences,
                  referenceType: "employer",
                  userReference: true,
                  actionCompleted: _ctx.actionCompleted,
                  onSave: _ctx.handleSaveReference,
                  onDelete: _ctx.handleDeleteReference
                }, null, 8, ["references", "actionCompleted", "onSave", "onDelete"])
              ]),
              _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
              _createElementVNode("section", null, [
                _createElementVNode("h5", null, [
                  _createVNode(_component_TranslatedText, { path: "references.character-references" })
                ]),
                _createVNode(_component_UserReferenceList, {
                  references: _ctx.characterReferences,
                  referenceType: "character",
                  userReference: true,
                  actionCompleted: _ctx.actionCompleted,
                  onSave: _ctx.handleSaveReference,
                  onDelete: _ctx.handleDeleteReference
                }, null, 8, ["references", "actionCompleted", "onSave", "onDelete"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}